var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.4917 1.66602H6.50833C3.475 1.66602 1.66666 3.47435 1.66666 6.50768V13.4827C1.66666 16.5244 3.475 18.3327 6.50833 18.3327H13.4833C16.5167 18.3327 18.325 16.5244 18.325 13.491V6.50768C18.3333 3.47435 16.525 1.66602 13.4917 1.66602Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8833 10L10.625 9.55833V6.73333H10.925C11.6 6.73333 12.15 7.325 12.15 8.05C12.15 8.39167 12.4333 8.675 12.775 8.675C13.1167 8.675 13.4 8.39167 13.4 8.05C13.4 6.63333 12.2917 5.48333 10.925 5.48333H10.625V5C10.625 4.65833 10.3417 4.375 10 4.375C9.65833 4.375 9.375 4.65833 9.375 5V5.48333H8.83333C7.6 5.48333 6.59167 6.525 6.59167 7.8C6.59167 9.29167 7.45833 9.76667 8.11667 10L9.375 10.4417V13.2583H9.075C8.4 13.2583 7.85 12.6667 7.85 11.9417C7.85 11.6 7.56667 11.3167 7.225 11.3167C6.88333 11.3167 6.6 11.6 6.6 11.9417C6.6 13.3583 7.70833 14.5083 9.075 14.5083H9.375V15C9.375 15.3417 9.65833 15.625 10 15.625C10.3417 15.625 10.625 15.3417 10.625 15V14.5167H11.1667C12.4 14.5167 13.4083 13.475 13.4083 12.2C13.4 10.7 12.5333 10.225 11.8833 10ZM8.53333 8.825C8.10833 8.675 7.85 8.53333 7.85 7.80833C7.85 7.21667 8.29167 6.74167 8.84167 6.74167H9.38333V9.125L8.53333 8.825ZM11.1667 13.2667H10.625V10.8833L11.4667 11.175C11.8917 11.325 12.15 11.4667 12.15 12.1917C12.15 12.7833 11.7083 13.2667 11.1667 13.2667Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSquare);
export default __webpack_public_path__ + "static/media/dollar-square.a20b72afc11a2e2e6e9e03d6ff092810.svg";
export { ForwardRef as ReactComponent };